import { BehaviorSubject, Observable } from "rxjs";

abstract class Cubit<State> {
    private stateSubject: BehaviorSubject<State>;
    public get stream(): Observable<State> {
        return this.stateSubject.asObservable();
    }
    public get state(): State {
        return this.stateSubject.getValue();
    }
    public constructor(initialState: State) {
        this.stateSubject = new BehaviorSubject<State>(initialState);
    }
    public dispose(): () => void {
        return this.stateSubject.unsubscribe
    }
    public emit(state: State): void {
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            console.log('CURRENT-STATE',state);
        }
        this.stateSubject.next(state);
    }
}

export default Cubit;